export function SleepingScientist({ size = 180 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={(size * 200) / 220}
      viewBox="0 0 220 200"
      role="img"
      aria-label="A scientist asleep wearing a sleep mask, beside a gently fizzing flask"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="demo-sleep-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#15aabf" />
          <stop offset="100%" stopColor="#9775fa" />
        </linearGradient>
        <style>{`
          @media (prefers-reduced-motion: no-preference) {
            .demo-float { animation: demo-float 3.2s ease-in-out infinite; transform-box: fill-box; transform-origin: center; }
            .demo-float-2 { animation-delay: 0.5s; }
            .demo-float-3 { animation-delay: 1s; }
          }
          @keyframes demo-float {
            0% { opacity: 0; transform: translateY(7px) scale(0.85); }
            35% { opacity: 1; }
            100% { opacity: 0; transform: translateY(-11px) scale(1.12); }
          }
        `}</style>
      </defs>

      <g stroke="url(#demo-sleep-grad)" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="92" cy="100" r="86" />
        <circle cx="88" cy="104" r="46" />
        <rect x="56" y="86" width="64" height="24" rx="12" />
        <path d="M56 97 H44 M120 97 H132" strokeWidth="4" />
        <ellipse cx="88" cy="128" rx="7" ry="5" strokeWidth="4" />

        <path d="M157 112 H175" strokeWidth="4" />
        <path d="M160 112 V130 L146 164 H186 L172 130 V112" strokeWidth="4" />
        <path d="M150 156 H182" strokeWidth="4" />
      </g>

      <g fill="url(#demo-sleep-grad)">
        <circle className="demo-float demo-float-2" cx="163" cy="103" r="3" />
        <circle className="demo-float demo-float-3" cx="171" cy="95" r="2.5" />
      </g>

      <g
        fill="url(#demo-sleep-grad)"
        fontFamily="-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        fontWeight="700"
      >
        <text className="demo-float" x="128" y="66" fontSize="18">
          z
        </text>
        <text className="demo-float demo-float-2" x="146" y="48" fontSize="24">
          z
        </text>
        <text className="demo-float demo-float-3" x="166" y="30" fontSize="30">
          z
        </text>
      </g>
    </svg>
  );
}
